var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39729 6.34821L14.8585 0H13.5644L8.8224 5.51207L5.035 0H0.666687L6.39397 8.33522L0.666687 14.9923H1.96089L6.96853 9.17137L10.9683 14.9923H15.3366L9.39697 6.34821H9.39729ZM7.62469 8.40865L7.0444 7.57865L2.42721 0.974259H4.41504L8.14116 6.30422L8.72145 7.13422L13.565 14.0623H11.5772L7.62469 8.40897V8.40865Z",
    fill: "#032D42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6699,
    height: 15,
    fill: "white",
    transform: "translate(0.666687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1606e7847fa53d1a4697190b82ade37b.svg";
export { ForwardRef as ReactComponent };